import React from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import CTALink from "./CTALink";
import styles from "./blog-post.module.css";

import { getFluidGatsbyImage } from "gatsby-source-sanity";
const maybeImage = (illustration) => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const fluidProps = getFluidGatsbyImage(
      illustration.image.asset._id,
      { maxWidth: 600 },
      clientConfig.sanity
    );

    img = (
      <img className="w-full md:w-4/5 z-50" src={fluidProps.src} alt={illustration.image.alt} />
    );
  }
  return img;
};

function Hero(props) {
  const img = maybeImage(props.illustration);
  return (
    <div className="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center">
      {/* Left col */}
      <div className="w-full md:w-3/5 py-6 text-center">{img}</div>

      {/* Right col */}
      <div className="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left">
        <p className="uppercase tracking-loose w-full">{props.label}</p>
        <h1 className="my-4 text-5xl font-bold leading-tight text-yellow-700">{props.heading}</h1>
        <div className={"leading-normal text-xl mb-8 " + styles.mainContent}>
          <PortableText blocks={props.tagline} />
        </div>
        {props.cta && props.cta.title && (
          <CTALink
            {...props.cta}
            buttonActionClass="mx-auto xl:ml-4 hover:underline bg-white text-gray-100 font-bold rounded-full my-6 py-4 px-8 bg-yellow-700 shadow-lg cursor-pointer"
          />
        )}
      </div>
    </div>
  );
}

export default Hero;
